import { render, staticRenderFns } from "./TipoManutencao.vue?vue&type=template&id=28d14437&"
import script from "./TipoManutencao.vue?vue&type=script&lang=js&"
export * from "./TipoManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports